import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=b242d690"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"
import style0 from "./Index.vue?vue&type=style&index=0&id=b242d690&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b242d690')) {
      api.createRecord('b242d690', component.options)
    } else {
      api.reload('b242d690', component.options)
    }
    module.hot.accept("./Index.vue?vue&type=template&id=b242d690", function () {
      api.rerender('b242d690', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layouts/vertical/Index.vue"
export default component.exports